'use client';

import { Flex, Text } from '@chakra-ui/react';
import { memo, useCallback, useState } from 'react';

import CashBalanceCard from '@features/cashBalance/CashBalanceCard';
import TransactionHistory from '@features/cashBalance/TransactionHistory';
import { allCashBalances } from 'helpers/fakeData';

const CashBalancePage = () => {
  // The selected currency scopes the whole page — balance card, deposit/withdraw
  // rails, and the transaction history below all follow it.
  const [currency, setCurrency] = useState(allCashBalances[0]?.currency ?? 'USDC');

  const onCurrencyChange = useCallback((details: { value: string[] }) => {
    const next = details.value[0];
    if (next != null) {
      setCurrency(next);
    }
  }, []);

  return (
    <Flex flexDirection="column" gap={4} h="full" p={4}>
      <Text color="text.secondary" fontSize="sm" fontWeight="medium">
        Your cash balance can be used to create demand contracts or commit to contracts
      </Text>
      <CashBalanceCard currency={currency} onCurrencyChange={onCurrencyChange} />
      <TransactionHistory currency={currency} />
    </Flex>
  );
};

export default memo(CashBalancePage);
